"use client";

import Header from "@/components/sections/header";
import Footer from "@/components/sections/footer";
import { TranslationsProvider } from "@/lib/i18n/TranslationsProvider";

export default function NotFoundLayout({
  children,
  locale,
}: {
  children: React.ReactNode;
  locale: "de" | "en";
}) {
  return (
    <TranslationsProvider locale={locale}>
      <div className="flex min-h-screen flex-col">
        <Header />
        <main className="flex-1">
          {children}
        </main>
        <Footer />
      </div>
    </TranslationsProvider>
  );
}
